import { render, staticRenderFns } from "./AccountAlertBellCobrand.vue?vue&type=template&id=525e93dc&scoped=true"
import script from "./AccountAlertBellCobrand.vue?vue&type=script&lang=ts"
export * from "./AccountAlertBellCobrand.vue?vue&type=script&lang=ts"
import style0 from "./AccountAlertBellCobrand.vue?vue&type=style&index=0&id=525e93dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525e93dc",
  null
  
)

export default component.exports